module.exports = __webpack_public_path__ + "img/mesa_hl28.0c44723a.png";